import { render, staticRenderFns } from "./crownConfig.vue?vue&type=template&id=4e88da7e&"
import script from "./crownConfig.vue?vue&type=script&lang=js&"
export * from "./crownConfig.vue?vue&type=script&lang=js&"
import style0 from "./crownConfig.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports